/**
 * This works with the segment analytics api
 * https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/
 *
 * See Guild's Clickable Event Guidelines for data format:
 * https://guild-education.atlassian.net/wiki/spaces/GAI/pages/2174025973/General+Clickable+Event+Guidelines+PP+Migration+to+Webiny
 */
import { snakeCase } from 'lodash';
import { logDebug } from './appHelper';
export const PRODUCT = 'global';
let currentUser;
const isExternalUrl = (url) => {
    try {
        const parsedUrl = new URL(url);
        return parsedUrl.hostname !== window.location.hostname;
    }
    catch {
        return false;
    }
};
// Click events only, use trackEvent for other events
export const trackClickEvent = (text, tag, type = 'button', localizedText, extraData) => {
    trackEvent('Clickable', {
        text: text.toLowerCase(),
        tag: snakeCase(tag.toLowerCase()),
        type: type.toLowerCase(),
        localizedText: localizedText?.toLocaleLowerCase(),
        ...extraData,
    });
};
// Segment identify
// https://segment.com/docs/sources/website/analytics.js/#identify
export const identifyUser = (user) => {
    currentUser = user;
    if (window.analytics) {
        window.analytics.identify(user?.id ?? null, {
            clientId: user.clientId,
        }); // Add traits as needed (make sure the data sent adheres to PII rules)
        logDebug(`identifyUser: ${JSON.stringify({ id: user.id, clientId: user.clientId })}`);
    }
};
// Clear the logged in user info
export const resetAnalytics = () => {
    currentUser = undefined;
};
// Segment page
// https://segment.com/docs/sources/website/analytics.js/#page
export const logLocationChange = () => {
    logDebug(`logLocationChange: ${window.location.pathname}${window.location.search}`);
    // pass the product so it's saved as the "name" field in Segment
    window.analytics && window.analytics.page(PRODUCT);
};
// Segment track
// https://segment.com/docs/connections/spec/track/
export const trackEvent = (eventName, extraData) => {
    if (window.analytics) {
        const { url, ...rest } = extraData || {};
        const args = {
            loggedIn: !!currentUser,
            clientId: currentUser?.clientId ?? -1,
            product: PRODUCT,
            ...rest,
        };
        if (url) {
            const urlLower = url.toLowerCase();
            if (urlLower.startsWith('http') && isExternalUrl(url)) {
                args.external_url = url;
            }
            else {
                args.url = url;
            }
        }
        logDebug(`trackEvent_${eventName}: ${JSON.stringify(args)}`);
        window.analytics.track(eventName, args);
    }
};
